export default "__VITE_ASSET__38e8dc3b__"